import { useState } from "react";
import { OrientationToggle } from "@/components/site/Lamina";
import { SizeCompare } from "@/components/site/SizeCompare";
import { ADVANTAGES } from "@/content/texts";
import { useCatalog, useSeo } from "@/lib/site";

export default function ProductsPage() {
  useSeo({
    title: "Láminas magnéticas personalizadas con fotos | LUMINA STUDIO",
    description: "Láminas personalizadas con fotos en tres tamaños, horizontal o vertical, con efecto flotante y bordes redondeados. Cuadros metálicos personalizados hechos en Colombia.",
  });
  const { data } = useCatalog();
  const [orientation, setOrientation] = useState("horizontal");
  const products = (data?.products || []).filter((p) => p.available);
  return (
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 py-10 sm:py-16 text-center">
      <h1 data-testid="products-title" className="font-serif-display text-[40px] sm:text-[56px] font-medium leading-[1.05]">Elige tu LUMINA</h1>
      <p className="mt-3 text-base sm:text-xl text-[#080808]/80">Compara tamaños y encuentra el ideal para tu recuerdo</p>
      <div className="mt-8"><OrientationToggle value={orientation} onChange={setOrientation} testId="products-orientation" /></div>
      <div className="mt-8">{products.length > 0 && <SizeCompare products={products} orientation={orientation} />}</div>
      <p className="mt-10 text-center text-[0.8rem] font-medium uppercase tracking-[0.2em] text-[#B18A4B]">{ADVANTAGES}</p>
    </div>
  );
}
